"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconLocation = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconLocation = function SvgIconLocation(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.04596 0C3.64959 0 1.70001 1.94958 1.70001 4.34592C1.70001 7.31986 5.58921 11.6858 5.75479 11.8702C5.91032 12.0434 6.18187 12.0431 6.33712 11.8702C6.50271 11.6858 10.3919 7.31986 10.3919 4.34592C10.3919 1.94958 8.4423 0 6.04596 0ZM6.04596 6.53248C4.84029 6.53248 3.85943 5.55159 3.85943 4.34592C3.85943 3.14025 4.84031 2.15939 6.04596 2.15939C7.25161 2.15939 8.23246 3.14027 8.23246 4.34595C8.23246 5.55162 7.25161 6.53248 6.04596 6.53248Z",
    fill: "#4F566B"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  }))));
};

exports.SvgIconLocation = SvgIconLocation;